"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.module.scss");
var classcat_1 = require("classcat");
var TableContext_1 = require("./TableContext");
var Column = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, width = _a.width, disableEllipsis = _a.disableEllipsis, style = _a.style, others = tslib_1.__rest(_a, ["className", "children", "width", "disableEllipsis", "style"]);
    var _b;
    var context = React.useContext(TableContext_1.default);
    var columnStyle = tslib_1.__assign({}, style, { width: width || context.minColumnWidth });
    return (React.createElement("div", tslib_1.__assign({ ref: ref, "data-column": true }, others, { style: columnStyle, className: classcat_1.default([theme.column, className, (_b = {},
                _b[theme.ellipsis] = !disableEllipsis,
                _b)]) }), children));
});
exports.default = React.memo(Column);
